import React from 'react';
import PropTypes from 'prop-types';
import {
  StyledBoxPublished,
  TilePublished,
  OverwriteDate,
  CreditArticle,
  BoxCategories
} from './style';

import { SQUARED_SMALL } from '../../../utils/crops';

const BoxPublished = ({ className, children, author, publishDate }) => {
  const association = Object.keys(author.association).length > 0;
  const user = Object.keys(author.user).length > 0;
  const showAuthor = association || user;

  return (
    <StyledBoxPublished className={className}>
      <TilePublished>
        Publicado <OverwriteDate fromNow>{publishDate}</OverwriteDate>{' '}
        {showAuthor && 'por'} 
      </TilePublished>
      {showAuthor && (
        <CreditArticle
          author={author}
          departamento="Objetivo Bienestar"
          pathImage={author.user.userImg || author.association.associationImg}
          defaultCrop={SQUARED_SMALL}
          alt="Usuario"
        />
      )}
      <BoxCategories>{children}</BoxCategories>
    </StyledBoxPublished>
  );
};

BoxPublished.propTypes = {
  className: PropTypes.string,
  author: PropTypes.shape({
    user: PropTypes.shape({
      name: PropTypes.string
    }),
    association: PropTypes.shape({
      name: PropTypes.string
    })
  })
};

BoxPublished.defaultProps = {
  author: {
    user: {
      name: null
    },
    association: {
      name: null
    }
  }
};

export default BoxPublished;
